import React from "react";
import { useEffect } from "react";
function Loading ({loadingText}) {
if(!loadingText){

    loadingText = "Loading..."
}

return (
   <div className="h-full w-full flex items-center justify-center" >
      
      <div className="text-center relative p-16">
        
        {/* Texte de chargement */}
        <div className="loading-text mb-12">
          <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-black via-blue-500 to-black text-xl font-semibold tracking-wide">
                {loadingText}
              </h2>
        </div>

        {/* Container principal des animations */}
        <div className="relative">
          
          {/* Pointillés flottants périphériques */}
          <div className="absolute inset-0 w-80 h-32 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2">
            {[...Array(8)].map((_, i) => (
              <div
                key={`floating-${i}`}
                className="floating-dot absolute w-1 h-1 bg-blue-500 rounded-full opacity-0"
                style={{ 
                  '--delay': `${i * 0.2}s`,
                  '--duration': '3s'
                }}
              />
            ))}
          </div>

          {/* Loader principal - pointillés centraux */}
          <div className="flex justify-center items-center gap-3 relative z-10">
            {[...Array(8)].map((_, i) => (
              <div
                key={`center-${i}`}
                className="center-dot w-2 h-2 bg-blue-800 rounded-full"
                style={{ 
                  '--i': i + 1,
                  animationDelay: `${i * 0.3}s`
                }}
              />
            ))}
          </div>

        </div>

     

      </div>

      <style jsx>{`
        .loading-text h2 {
          animation: textFade 4s ease-in-out infinite;
        }

        @keyframes textFade {
          0%, 100% { opacity: 0.8; }
          50% { opacity: 1; }
        }

        .center-dot {
          animation: centerPulse 1.5s ease-in-out infinite;
        }

        @keyframes centerPulse {
          0%, 100% {
            transform: scale(1);
            opacity: 0.6;
          }
          50% {
            transform: scale(1.3);
            opacity: 1;
            background: #60a5fa;
          }
        }

        .floating-dot:nth-child(1) {
          animation: float1 var(--duration) ease-in-out infinite var(--delay);
        }
        .floating-dot:nth-child(2) {
          animation: float2 var(--duration) ease-in-out infinite var(--delay);
        }
        .floating-dot:nth-child(3) {
          animation: float3 var(--duration) ease-in-out infinite var(--delay);
        }
        .floating-dot:nth-child(4) {
          animation: float4 var(--duration) ease-in-out infinite var(--delay);
        }
        .floating-dot:nth-child(5) {
          animation: float5 var(--duration) ease-in-out infinite var(--delay);
        }
        .floating-dot:nth-child(6) {
          animation: float6 var(--duration) ease-in-out infinite var(--delay);
        }
        .floating-dot:nth-child(7) {
          animation: float7 var(--duration) ease-in-out infinite var(--delay);
        }
        .floating-dot:nth-child(8) {
          animation: float8 var(--duration) ease-in-out infinite var(--delay);
        }

        @keyframes float1 {
          0% { left: -20px; top: 20px; opacity: 0; }
          25% { opacity: 1; }
          50% { left: 50px; top: -10px; opacity: 0.8; }
          75% { opacity: 1; }
          100% { left: 120px; top: 30px; opacity: 0; }
        }

        @keyframes float2 {
          0% { left: 300px; top: -20px; opacity: 0; }
          25% { opacity: 1; }
          50% { left: 200px; top: 50px; opacity: 0.8; }
          75% { opacity: 1; }
          100% { left: 100px; top: -10px; opacity: 0; }
        }

        @keyframes float3 {
          0% { left: -30px; top: 80px; opacity: 0; }
          25% { opacity: 1; }
          50% { left: 80px; top: 100px; opacity: 0.8; }
          75% { opacity: 1; }
          100% { left: 200px; top: 60px; opacity: 0; }
        }

        @keyframes float4 {
          0% { left: 250px; top: 100px; opacity: 0; }
          25% { opacity: 1; }
          50% { left: 150px; top: 20px; opacity: 0.8; }
          75% { opacity: 1; }
          100% { left: 50px; top: 80px; opacity: 0; }
        }

        @keyframes float5 {
          0% { left: 100px; top: -30px; opacity: 0; }
          25% { opacity: 1; }
          50% { left: 180px; top: 30px; opacity: 0.8; }
          75% { opacity: 1; }
          100% { left: 260px; top: 90px; opacity: 0; }
        }

        @keyframes float6 {
          0% { left: 300px; top: 50px; opacity: 0; }
          25% { opacity: 1; }
          50% { left: 220px; top: 80px; opacity: 0.8; }
          75% { opacity: 1; }
          100% { left: 140px; top: 10px; opacity: 0; }
        }

        @keyframes float7 {
          0% { left: 20px; top: 110px; opacity: 0; }
          25% { opacity: 1; }
          50% { left: 120px; top: 70px; opacity: 0.8; }
          75% { opacity: 1; }
          100% { left: 220px; top: 110px; opacity: 0; }
        }

        @keyframes float8 {
          0% { left: 280px; top: 20px; opacity: 0; }
          25% { opacity: 1; }
          50% { left: 160px; top: 90px; opacity: 0.8; }
          75% { opacity: 1; }
          100% { left: 40px; top: 40px; opacity: 0; }
        }

        .letter-spacing-wide {
          letter-spacing: 1px;
        }
      `}</style>
    </div>
)

}

export default Loading;